import { IFaqSubSection } from '@propertypal/shared/src/types/strapi';
import Link from 'next/link';
import React from 'react';
import { SmallHeading, Text } from '../typography';
import { FaqSection, FaqSections, ButtonLink } from './FaqSectionGrid.style';

interface FaqSectionGridProps {
  data: IFaqSubSection[] | null;
  link?: string;
}

const FaqSectionGrid: React.FC<FaqSectionGridProps> = ({ data, link }) => {
  if (!data?.length) return null;

  return (
    <FaqSections data-testid="faq-section-grid">
      {data.map(({ attributes, id }) => (
        <FaqSection key={id} data-testid="faq-section-item">
          <div>
            {attributes.icon && (
              <img
                src={attributes.icon?.data?.attributes.url}
                alt={attributes.icon?.data?.attributes.alternativeText || `${attributes.subSection} FAQ`}
              />
            )}
            <SmallHeading fontSize={24} mb={5}>
              {attributes.subSection}
            </SmallHeading>
            <Text mb={30}>{attributes.subtitle}</Text>
          </div>
          <Link href={`/faq/${link || ''}${attributes.slug}`} prefetch={false} data-testid="faq-sub-section-link">
            <ButtonLink>Find out more</ButtonLink>
          </Link>
        </FaqSection>
      ))}
    </FaqSections>
  );
};

export default FaqSectionGrid;
